import { withAuthenticationRequired } from '@auth0/auth0-react'
import { NotFound } from 'modules/NotFound'
import { Route, Routes } from 'react-router'
import { ScheduleSuccess } from '../../../components/Appointment'
import { AppointmentProvider, SchedulingModeProvider } from '../../../hooks'
import { Cancellation } from './Cancellation'
import { Reschedule } from './Reschedule'

const Page = () => (
  <AppointmentProvider>
    <SchedulingModeProvider>
      <Routes>
        <Route element={<Cancellation />} path="cancel/*" />
        <Route element={<Reschedule />} path="reschedule/*" />
        <Route element={<ScheduleSuccess />} path="success/*" />
        <Route element={<NotFound />} path="*" />
      </Routes>
    </SchedulingModeProvider>
  </AppointmentProvider>
)

const Appointment = withAuthenticationRequired(Page)

export { Appointment }
